import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  margin-top: 20px;\n\n  display: flex;\n  height: 48px;\n  padding: 7px 16px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 2px;\n\n  border-radius: 6px;\n  background: ",
        ";\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 3px;\n  color: ",
        ";\n\n  svg {\n    width: 14px;\n    height: 14px;\n\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 12px;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal([
        "\n  color: ",
        ";\n  text-align: center;\n\n  /* ref/typo/regular/10 */\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 16px; /* 160% */\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useBooks } from "@/components/Books/Order";
import Icon from "@/components/icon/Icon";
import { Goodnote6, Package } from "@/components/icon/IconList";
import styled from "styled-components";
const BooksBadge = ()=>{
    const { isBooks  } = useBooks();
    return /*#__PURE__*/ _jsxs(BadgeLayout, {
        children: [
            /*#__PURE__*/ _jsxs(VendorTextBox, {
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        icon: isBooks ? Package : Goodnote6
                    }),
                    /*#__PURE__*/ _jsxs(VendorText, {
                        children: [
                            isBooks ? "도서 배송" : "굿노트6 eBook",
                            " 상품"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(DescriptionText, {
                children: isBooks ? "실물 도서가 배송되는 상품입니다." : "굿노트6를 통해 eBook으로 이용가능한 상품입니다."
            })
        ]
    });
};
export default BooksBadge;
const BadgeLayout = styled.div.withConfig({
    componentId: "sc-dd3dfd56-0"
})(_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.new.colors.sol_gray_0;
});
const VendorTextBox = styled.div.withConfig({
    componentId: "sc-dd3dfd56-1"
})(_templateObject1(), (param)=>{
    let { theme  } = param;
    return theme.new.colors.sol_gray_900;
}, (param)=>{
    let { theme  } = param;
    return theme.new.colors.sol_gray_900;
});
const VendorText = styled.span.withConfig({
    componentId: "sc-dd3dfd56-2"
})(_templateObject2());
const DescriptionText = styled.span.withConfig({
    componentId: "sc-dd3dfd56-3"
})(_templateObject3(), (param)=>{
    let { theme  } = param;
    return theme.new.colors.sol_gray_500;
});
